import React, { useEffect, useRef } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { Collapse } from "bootstrap";

export default function Navbar() {
    const { logout } = useAuth();
    const collapseRef = useRef(null);
    const location = useLocation(); // watch route changes

    useEffect(() => {
        // Initialize Bootstrap collapse
        if (collapseRef.current) {
            collapseRef.current = new Collapse(collapseRef.current, { toggle: false });
        }
    }, []);

    useEffect(() => {
        // Collapse menu automatically on route change
        const collapseElement = document.getElementById("adminNavbar");
        const bsCollapse = Collapse.getInstance(collapseElement);
        if (bsCollapse) {
            bsCollapse.hide();
        }
    }, [location]); // runs every time the route changes

    return (
        <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">LaWeKa Admin</Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#adminNavbar"
                    aria-controls="adminNavbar"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div
                    className="collapse navbar-collapse"
                    id="adminNavbar"
                    ref={collapseRef}
                >
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/">Dashboard</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/users">Users</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/cards">Cards</NavLink>
                        </li>
                        <li className="nav-item">
                            <NavLink className="nav-link" to="/locations">Locations</NavLink>
                        </li>
                    </ul>
                    <button onClick={logout} className="btn btn-outline-light ms-auto">
                        Logout
                    </button>
                </div>
            </div>
        </nav>
    );
}
